import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import config from "../api/config";
import TariffCard from "../components/TariffCard/TariffCard";
import Button from "@mui/material/Button";
import { setToast } from "../redux/actions/ToastAction";
import TariffCreator from "../components/AddTariff";
import { Skeleton, Snackbar } from "@mui/material";
import Alert from "../components/alert";

const AddTariff = () => {
  // variables
  const [allTariffs, setAllTariffs] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [tariff, setTariff] = useState(null);
  // get all tariffs
  const refresher = async (bool) => {
    if (bool) {
      setLoading(true);
      await config
        .get(`/api/advertisingTariff/v1`)
        .then((data) => {
          setLoading(false);
          setAllTariffs(
            data.data.objectKoinot.sort((a, b) =>
              a.countKey > b.countKey ? 1 : -1
            )
          );
        })
        .catch((err) => console.error(err?.message));
    }
  };
  useEffect(() => {
    refresher(true);
  }, []);
  // open modal
  const handleCreate = (id) => {
    setModal(true);
  };
  const reducer = useSelector((state) => state.reducer.toast);
  const dispatch = useDispatch();

  const toastHandler = () => {
    dispatch(setToast(false, "success", "Успешно Изменено"));
  };
  const editTariff = (e) => {

    setTariff(e);
    setModal(true);
  };
  const deleteTarifff = async (e) => {
    try {
      await config.delete(`/api/advertisingTariff/v1/${e}`, e);
      dispatch(setToast("true", "success", "Успешно удалено"));
      refresher(true);
    } catch (e) {
      dispatch(
        setToast("true", "error", "Что-то пошло не так, попробуйте еще раз")
      );
      refresher(true);
    }
  };
  const changeActive = async (id) => {
    try {
      await config.post(`/api/advertisingTariff/v1/active/${id}`);
      refresher(true);
    } catch (e) {
      dispatch(
        setToast("true", "error", "Что-то пошло не так, попробуйте еще раз")
      );
      refresher(true);
    }
  };
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <h1 className="my-3">Все тарифы</h1>
        <Button onClick={handleCreate} variant="contained">
          Создать новый
        </Button>
      </div>
      <div className="row">
        {!loading && allTariffs !== null ? (
          allTariffs.map((v, i) => (
            <div className="col-lg-3 col-sm-6 ">
              <TariffCard
                key={i}
                name={v.name}
                keywords={v.countKey}
                date={v.countDay}
                price={v.price}
                data={v}
                activeHandler={changeActive}
                edit={editTariff}
                delete={deleteTarifff}
              />
            </div>
          ))
        ) : (
          <div className="row mb-5">
            <div className="col-md-3 col-sm-6">
              <Skeleton
                variant="rectangular"
                width={"100%"}
                height={200}
                animation="wave"
              />
            </div>
            <div className="col-md-3 col-sm-6">
              <Skeleton
                variant="rectangular"
                width={"100%"}
                height={200}
                animation="wave"
              />
            </div>
            <div className="col-md-3 col-sm-6">
              <Skeleton
                variant="rectangular"
                width={"100%"}
                height={200}
                animation="wave"
              />
            </div>
            <div className="col-md-3 col-sm-6">
              <Skeleton
                variant="rectangular"
                width={"100%"}
                height={200}
                animation="wave"
              />
            </div>{" "}
          </div>
        )}
        <br />
        <Snackbar
          open={reducer.toast}
          autoHideDuration={4000}
          onClose={toastHandler}
        >
          <Alert
            onClose={toastHandler}
            severity={reducer.severity}
            sx={{ width: "100%" }}
          >
            {reducer.content}
          </Alert>
        </Snackbar>{" "}
        <TariffCreator
          modal={modal}
          tariff={tariff}
          setModal={(e) => setModal(e)}
          refresh={(e) => refresher(e)}
        />
      </div>
    </div>
  );
};

export default AddTariff;
